import { useServices } from "@/services-context.tsx";
import styles from "./index.module.scss";
import classNames from "classnames";

import infoCircle from "@/assets/info-circle.svg";
import warning from "@/assets/warning.svg";
import danger from "@/assets/danger.svg";
import successCircle from "@/assets/success-circle.svg";
import { Icon } from "@/elements-react/fix-icon";
import { ALERTS_LISTENER_NAME } from "@/context/alerts.ts";

export const FixAlert = () => {
  const { alerts } = useServices([ALERTS_LISTENER_NAME]);

  const iconMap: Record<string, string> = {
    danger: danger,
    warning: warning,
    success: successCircle,
    neutral: infoCircle,
  };

  if (!alerts.messages.length) {
    return <></>;
  }

  const alertMessage = alerts.messages[0];
  const icon = <Icon src={iconMap[alertMessage.type]} />;

  return (
    <div className={classNames(styles["dialog"], styles[alertMessage.type])}>
      <div className={styles["icon"]}>{icon}</div>
      <div className={styles["message"]}>
        <div>{alertMessage.message}</div>
      </div>
    </div>
  );
};
